import { useCallback, useEffect, useState } from "react";
import { X } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, fileUrl } from "@/lib/api";
import { SubmissionCard } from "@/components/deck/SubmissionCard";

export const InboxPanel = ({ open, onClose, onCount }) => {
  const [items, setItems] = useState([]);
  const [showAll, setShowAll] = useState(false);

  const load = useCallback(() => api.get("/inbox").then((r) => {
    setItems(r.data);
    onCount(r.data.filter((s) => s.status === "pending").length);
  }).catch(() => {}), [onCount]);

  useEffect(() => { load(); const t = setInterval(load, 15000); return () => clearInterval(t); }, [load]);

  const act = async (id, action) => {
    try {
      await api.post(`/inbox/${id}/${action}`);
      toast.success(action === "apply" ? "Stats applied to the roster" : "Submission dismissed");
      load();
    } catch (e) { toast.error(errMsg(e)); }
  };

  if (!open) return null;
  const list = showAll ? items : items.filter((s) => s.status === "pending");
  return (
    <aside className="lg lg-inbox" data-testid="deck-inbox-panel">
      <div style={{ display: "flex", alignItems: "center", marginBottom: 6 }}>
        <h3 style={{ fontSize: 18, margin: 0, marginRight: "auto" }}>Stat inbox</h3>
        <button className="lg-btn ghost sm" onClick={onClose} data-testid="deck-inbox-close"><X size={14} /></button>
      </div>
      <p style={{ fontSize: 13, color: "var(--muted)", marginBottom: 14 }}>Members' own stat updates from the enlist page. New applicants go straight to Recruit Watch.</p>
      <label style={{ fontSize: 13, display: "flex", gap: 6, marginBottom: 14 }}>
        <input type="checkbox" checked={showAll} onChange={(e) => setShowAll(e.target.checked)} data-testid="deck-inbox-show-all" />Show applied & dismissed
      </label>
      {list.length === 0 && <p style={{ fontSize: 14, color: "var(--ink-soft)" }} data-testid="deck-inbox-empty">Nothing waiting.</p>}
      {list.map((s) => <SubmissionCard key={s.id} s={s} onAct={act} />)}
      <Applicants open={open} />
    </aside>
  );
};

const Applicants = ({ open }) => {
  const [rows, setRows] = useState([]);
  useEffect(() => { if (open) api.get("/inbox/applicants").then((r) => setRows(r.data)).catch(() => {}); }, [open]);
  if (!rows.length) return null;
  return (
    <section style={{ marginTop: 22 }} data-testid="deck-applicants">
      <h3 style={{ fontSize: 16, marginBottom: 6 }}>Site applicants</h3>
      <p style={{ fontSize: 13, color: "var(--muted)", marginBottom: 12 }}>Already in Recruit Watch. Their screenshots are here.</p>
      {rows.map((r) => (
        <div className="lg-sub" key={r.id} data-testid={`applicant-${r.id}`}>
          <strong>{r.name}</strong>
          <div style={{ fontSize: 13, color: "var(--ink-soft)", margin: "4px 0" }}>
            Power {r.power?.toLocaleString() ?? "—"} · Participation {r.participation?.toLocaleString() ?? "—"}{r.contact ? ` · ${r.contact}` : ""}
          </div>
          {r.images?.length > 0 && <div className="lg-photos">{r.images.map((u) => <a key={u} className="lg-thumb" href={fileUrl(u)} target="_blank" rel="noreferrer"><img src={fileUrl(u)} alt="Applicant screenshot" /></a>)}</div>}
        </div>
      ))}
    </section>
  );
};
